import { Fragment } from "react";

import "./style.scss";
import { useLoading, Bars } from "@agney/react-loading";

const FullPageLoadingIcon = () => {
  const { containerProps, indicatorEl } = useLoading({
    loading: true,
    indicator: <Bars width="50" />,
    loaderProps: {
      valueText: "Working...",
      style: { color: "#1E6685" },
    },
  });

  return (
    <div aria-busy={true}>
      <div className="modal-backdrop-transparent" />
      <div className="full-page-loading">
        <section {...containerProps}>
          {indicatorEl} {/* renders only while loading */}
        </section>
      </div>
    </div>
  );
};

FullPageLoadingIcon.propTypes = {};

export default FullPageLoadingIcon;
